import { CommonService } from './../../page/common.service';
import { Component, OnInit, ElementRef, ViewChild, HostListener, Input, AfterViewInit, AfterViewChecked } from '@angular/core';

@Component({
  selector: "app-custom-scrollbar",
  templateUrl: "./custom-scrollbar.component.html",
  styleUrls: ["./custom-scrollbar.component.scss"]
})
export class CustomScrollbarComponent implements OnInit, AfterViewChecked {
  @Input() containerScrollRef: HTMLDivElement;

  @ViewChild("knob") svgKnob: ElementRef;
  @ViewChild("knobShadow") svgKnobShadow: ElementRef;
  @ViewChild("knobArrow") svgKnobArrow: ElementRef;
  @ViewChild("scrollbarLine") svgScrollBarLine: ElementRef;
  initialKnobCenter: number[] = [30, 30];
  private isScrolling: boolean = false;
  private scrollPerc: number;
  showScrollbar: boolean = false;

  locationIdentifier: string; // Safari per evitare che vada in conflitto gli id impostati nelle defs dell'svg tra le pagine.

  private isMobile = false;

  constructor(
    private cs: CommonService
  ) {
  }

  ngOnInit() {
    this.locationIdentifier = this.cs.setLocationIdentifier();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.toggleScrollbar();
    }, 200);
  }

  ngAfterViewChecked() {}

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    this.toggleScrollbar();
  }

  @HostListener("mousedown", ["$event"])
  onKnobMouseDown(event: MouseEvent) {
    this.onMouseDownTouchStart(event.target, event);
  }

  @HostListener("touchstart", ["$event"])
  onKnobTouchStart(event: TouchEvent) {
    if (event.targetTouches.length == 1) {
      this.onMouseDownTouchStart(event.targetTouches[0].target, event);
    }
  }

  @HostListener("mousemove", ["$event"])
  onKnobMouseMove(event: MouseEvent) {
    this.onMouseMoveTouchMove(event.clientX, event.clientY);
  }

  @HostListener("touchmove", ["$event"])
  onKnobTouchMove(event: TouchEvent) {
    if (
      event.targetTouches.length == 1 &&
      event.targetTouches[0].target == this.svgKnob.nativeElement
    ) {
      this.onMouseMoveTouchMove(
        event.targetTouches[0].clientX,
        event.targetTouches[0].clientY
      );
    }
  }

  @HostListener("window:mouseup", ["$event"])
  onKnobMouseUp(event: MouseEvent) {
    this.onMouseUpTouchEnd(event);
  }

  @HostListener("window:touchend", ["$event"])
  onKnobTouchEnd(event: TouchEvent) {
    this.onMouseUpTouchEnd(event);
  }

  private onMouseDownTouchStart(eventTarget: EventTarget, event: Event) {
    if (
      eventTarget == this.svgKnob.nativeElement ||
      eventTarget == this.svgKnobArrow.nativeElement
    ) {
      event.preventDefault();
      this.isScrolling = true;
    }
  }

  private onMouseUpTouchEnd(event: Event) {
    if (this.isScrolling) {
      event.preventDefault();
      this.isScrolling = !this.isScrolling;
    }
  }

  private onMouseMoveTouchMove(eventClientX: number, eventClientY: number) {
    if (this.isScrolling) {
      const barData = this.getElementData(this.svgScrollBarLine);
      const knobData = this.getElementData(this.svgKnob);
      if (knobData.r && knobData.clientRect.x) {
        const knobCenterOnX = knobData.clientRect.x + knobData.r;
        const xMove = eventClientX - knobCenterOnX;
        const newCx = this.checkScrollingBarLimit(
          eventClientX,
          knobData,
          knobCenterOnX,
          xMove,
          barData
        );
        this.updateKnobPosition(newCx);
        const knobUpdatedX = this.getElementData(this.svgKnob).clientRect.x;
        this.calcScrollPercentage(
          barData.clientRect.x,
          knobUpdatedX + knobData.r,
          barData.clientRect.width
        );
      }
    }
  }

  private calcScrollPercentage(xRef: number, knobX: number, maxXref: number) {
    const knobXref = knobX - xRef;
    this.scrollPerc = (knobXref * 100) / maxXref;

    const scrollable =
      this.containerScrollRef.scrollWidth - this.containerScrollRef.clientWidth;
    this.containerScrollRef.scrollLeft = (scrollable * this.scrollPerc) / 100;
  }

  private getElementData(element: ElementRef) {
    return {
      cx: parseFloat(element.nativeElement.getAttributeNS(null, "cx")),
      cy: parseFloat(element.nativeElement.getAttributeNS(null, "cy")),
      r: parseFloat(element.nativeElement.getAttributeNS(null, "r")),
      clientRect: element.nativeElement.getBoundingClientRect()
    };
  }

  private updateKnobPosition(cx: number) {
    this.svgKnob.nativeElement.setAttribute("cx", cx);
    this.svgKnobShadow.nativeElement.setAttribute("cx", cx);
    this.svgKnobArrow.nativeElement.setAttribute("x", cx - 10);
  }

  private checkScrollingBarLimit(
    eventX: number,
    knobData,
    knobCenterX: number,
    xMove: number,
    barData
  ) {
    let newX = knobCenterX + xMove;
    if (eventX < knobCenterX && newX <= barData.clientRect.x) {
      return this.initialKnobCenter[0];
    } else if (
      eventX > knobCenterX &&
      newX >= barData.clientRect.x + barData.clientRect.width
    ) {
      return barData.clientRect.width + this.initialKnobCenter[0];
    } else {
      return knobData.cx + xMove;
    }
  }

  private toggleScrollbar() {
    if (
      this.containerScrollRef.scrollWidth > this.containerScrollRef.clientWidth && window.innerWidth > 675
    ) {
      this.showScrollbar = true;
    } else {
      this.showScrollbar = false;
    }
  }
}
